import * as React from 'react';
import { Icon } from '@alifd/next';
import * as classnames from "classnames"
import './index.scss';

const { useState } = React;

interface propTypes {
    productLightCustomizationList: {
        customType: string;
        moq: number;
    }[];
    price: {
        unit: string;
        unitEven: string;
    };
    lightCustomModel: string;
    customModel: string;
    i18n: any;
}

export default function Index ( props: propTypes ) {
    const [visible,setVisible] = useState( true );
    const { productLightCustomizationList,i18n,price, lightCustomModel, customModel} = props;

    const renderItem = ( item: { customType: string; moq: number; },index: number ) => {
        const cls = classnames( {
            "custom-item": true,
            "visible": index > 1 && visible
        } );
        return <div className={cls} key={index}>
            <span>{item.customType}</span>
            <span>{`(${i18n['marketAction_moq_name']} ${item.moq} ${item.moq > 1 ? price?.unitEven : price?.unit})`}</span>
        </div>;
    };

    const renderCustom = () => {
      if (lightCustomModel || customModel) {
        return <div id="product-custom"></div>
      }
    }

    if (customModel || lightCustomModel || productLightCustomizationList?.length > 0) {
      return <div className="customization">
              <label>{i18n["marketAction.customize"]}</label>
              <div className="custom-list">
                  {renderCustom()}
                  {productLightCustomizationList?.map( ( item,index ) => renderItem( item,index ) )}
                  {productLightCustomizationList?.length > 2 && <div className="toggle">
                      <a href="#" onClick={e => {
                          e.preventDefault();
                          setVisible( !visible );
                      }}>{visible ? i18n['marketAction.more'] : i18n['marketAction.less']}</a>
                      <Icon type={visible ? "arrow-down" : "arrow-up"} size="xxs" />
                  </div>}
              </div>
          </div>
    }else{
      return null;
    }

}
